import React from 'react';
import { CContainer, CBreadcrumb, CBreadcrumbItem, 
  CCard, CCardHeader, CCardBody, CRow, CCol } from '@coreui/react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from '../../hooks/useTranslation';
import CustomerInputs from '../../components/CustomerInputs/CustomerInputs';
import { addCustomerRequest } from '../../store/customer/customerActions';

const CreateCustomer = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const isLoading = useSelector(state => state.customerReducer.isLoading);
  const submitResponse = useSelector(state => state.customerReducer.addCustomerData);

  const handleSubmit = (data) => {
    dispatch(addCustomerRequest({ ...data, navigate }));
  };

  const handleCancel = () => {
    navigate('/customers');
  };

  return (
    <CContainer>
      <CBreadcrumb className="mb-4">
        <CBreadcrumbItem href="#/customers" 
        onClick={e => { e.preventDefault(); handleCancel(); }}>{t('customers')}</CBreadcrumbItem>
        <CBreadcrumbItem active>{t('createCustomer')}</CBreadcrumbItem>
      </CBreadcrumb>
      <CRow>
        <CCol xs={12}>
          <CCard>
            <CCardHeader><h4>{t('createCustomer')}</h4></CCardHeader>
            <CCardBody>
              <CustomerInputs onSubmit={handleSubmit}
               onCancel={handleCancel} isLoading={isLoading} 
               submitResponse={submitResponse} />
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  );
};

export default CreateCustomer; 